// CreatorSuggestions.styles.ts
import { makeStyles, Theme } from "@material-ui/core/styles";

export default makeStyles((theme: Theme) => ({
  sidebarCard: {
    maxHeight: "fit-content",
    width: "480px",
    maxWidth: "480px",
    // marginTop: "25px",
    border: "1px solid #FFFFFF1A",
    borderRadius: "16px",
    backgroundColor: "#0C0A09",
    padding: 24,
    // Disabled scrolling for desktop - removed maxHeight and overflowX
    [theme.breakpoints.down("md")]: {
      padding: "20px 5px 25px 5px",
    },
    [theme.breakpoints.down("sm")]: {
      border: 0,
      padding: 0,
      display: "flex",
      width: "100%",
      maxWidth: "100%",
      columnGap: "10px",
      overflowY: "auto",
      maxHeight: "600px",
    },
  },
  sidebarHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: theme.spacing(2),
    [theme.breakpoints.down("sm")]: {
      marginBottom: theme.spacing(1),
    },
  },
  hr: {
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  sidebarTitle: {
    display: "flex",
    alignItems: "center",
    color: "white",
    gap: theme.spacing(1),
  },
  creatorTitle: {
    fontWeight: 600,
    fontSize: "15px",
    color: "#FFFFFF",
  },
  /** Заголовок зверху картки «Suggested creators» (десктоп) */
  sidebarTitleDesktop: {
    fontSize: "20px",
    fontWeight: 600,
    color: "#FFFFFF",
    lineHeight: 1.3,
    marginBottom: 24,
  },
  seeMore: {
    color: "#FE5A97",
    cursor: "pointer",
    fontSize: "20px",
    fontWeight: 600,
    textDecoration: "underline",
    transition: "opacity 0.2s ease",
    "&:hover": {
      opacity: 0.8,
    },
  },
  creatorItem: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: theme.spacing(2),
    border: "none",
    padding: 0,
    backgroundColor: "transparent",
    borderRadius: 0,
    [theme.breakpoints.down("sm")]: {
      flexDirection: "row",
      alignItems: "center",
      padding: 0,
      width: 260,
      borderRadius: 16,
      border: "1px solid #363636",
      backgroundColor: "#131313",
      margin: 0,
      boxSizing: "border-box",
      columnGap: theme.spacing(2),
    },
  },
  creatorInfo: {
    display: "flex",
    alignItems: "center",
    color: "white",
    gap: theme.spacing(2),
    padding: 0,
    minWidth: 0,
    "& > div:last-child": {
      minWidth: 0,
      flex: 1,
    },
    [theme.breakpoints.down("sm")]: {
      padding: 12,
      gap: 10,
    },
  },
  followButton: {
    width: "auto",
    minWidth: "100px",
    borderRadius: 5,
    border: "1px solid #FE5A97",
    color: "#FFFFFF",
    textTransform: "none",
    backgroundColor: "transparent",
    fontWeight: 600,
    fontSize: 20,
    "&:hover": {
      backgroundColor: "rgba(240, 110, 196, 0.08)",
      borderColor: "#f06ec4",
    },
    "&:focus": {
      outline: "none",
    },
    "&.Mui-focusVisible": {
      outline: "none",
    },
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      fontSize: 16,
    },
  },
  plusIcon: {
    color: "#FFFFFF",
    marginRight: "4px",
  },
  avatar: {
    width: 38,
    height: 38,
    [theme.breakpoints.down("sm")]: {
      width: 36,
      height: 36,
    },
  },
  avatarWrapper: {
    position: "relative",
    display: "inline-flex",
  },
  creatorName: {
    fontSize: "18px",
    fontWeight: 600,
    fontHeight: "24px",
    color: "#FFFFFF",
    [theme.breakpoints.down("sm")]: {
      fontSize: "14px",
      lineHeight: "18px",
    },
  },
  creatorUserName: {
    fontSize: "14px",
    fontWeight: 600,
    fontHeight: "20px",
    color: "#FE5A97",
    [theme.breakpoints.down("sm")]: {
      fontSize: "14px",
    },
  },
  creatorBio: {
    fontSize: "12px",
    fontWeight: 400,
    color: "#FFFFFFE5",
    lineHeight: "100%",
    display: "-webkit-box",
    WebkitLineClamp: 2,
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
    textOverflow: "ellipsis",
    [theme.breakpoints.down("sm")]: {
      fontSize: "12px",
      lineHeight: "16px",
      display: "block",
      width: "100%",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
    },
  },
  followIconButton: {
    position: "absolute",
    right: -1,
    bottom: -6,
    width: 28,
    height: 28,
    borderRadius: 50,
    border: "1px solid #000",
    backgroundColor: "#FE5A97",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    transition: "opacity 0.2s ease",
    "&:disabled": {
      opacity: 0.6,
      cursor: "not-allowed",
    },
  },
  mobileSliderWrapper: {
    width: "100%",
    margin: "0 -16px",
    touchAction: "pan-y",
    "& .slick-slide": {
      padding: "0 8px",
    },
    "& .slick-list": {
      padding: "0 20px !important",
    },
  },
  sliderItem: {
    height: "100%",
    display: "flex",
    justifyContent: "center",
  },

  pendingButton: {
    border: "none",
    color: "#FFFFFF",
    textTransform: "none",
    backgroundColor: "transparent",
  },
  verifiedIcon: {
    color: "rgba(254, 90, 151, 1)",
  },
  followingButton: {
    borderColor: "#FE5A97",
    color: "#FFFFFF",
    textTransform: "none",
    backgroundColor: "transparent",
  },
}));
